export const RESET_STATE = 'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/RESET_STATE';
export const SET_NUTRITION_CATEGORY_TRANSLATION =
	'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/SET_NUTRITION_CATEGORY_TRANSLATION';
export const UPDATE_NUTRITION_CATEGORY_TRANSLATION =
	'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/UPDATE_NUTRITION_CATEGORY_TRANSLATION';

export const EDIT_BATCH_LIST_ITEM = 'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/EDIT_BATCH_LIST_ITEM';
export const REMOVE_BATCH_LIST_ITEM = 'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/REMOVE_BATCH_LIST_ITEM';
export const ADD_BATCH_LIST_ITEM_ROW = 'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/ADD_BATCH_LIST_ITEM_ROW';
export const RERENDER_TABLE = 'PRODUCT_NUTRITION_CATEGORY_TRANSLATION/RERENDER_TABLE';

export function setNutritionCategoryTranslation(payload) {
	return {
		type: SET_NUTRITION_CATEGORY_TRANSLATION,
		payload,
	};
}

export function updateNutritionCategoryTranslation(payload) {
	return {
		type: UPDATE_NUTRITION_CATEGORY_TRANSLATION,
		payload,
	};
}

export function resetState() {
	return {
		type: RESET_STATE,
	};
}

export function editBatchListItem(payload) {
	return {
		type: EDIT_BATCH_LIST_ITEM,
		payload,
	};
}

export function removeBatchListItem(payload) {
	return {
		type: REMOVE_BATCH_LIST_ITEM,
		payload,
	};
}

export function addBatchListItemRow() {
	return {
		type: ADD_BATCH_LIST_ITEM_ROW,
	};
}

export function rerenderTable() {
	return {
		type: RERENDER_TABLE,
	};
}
